export default {
  state: {
    previewThemeParentClass: '',
    previewThemeClass: '',
  },
  getters: {
    previewThemeParentClass: ({ previewThemeParentClass }) => previewThemeParentClass,
    previewThemeClass: ({ previewThemeClass }) => previewThemeClass,
  },
  actions: {
  },
  mutations: {
    setPreviewThemeParentClass (state, val) {
      state.previewThemeParentClass = val
    },
    setPreviewThemeClass (state, val) {
      state.previewThemeClass = val
    },
  }
}
